module.exports = __webpack_public_path__ + "static/media/title-binance-nft-mobile.ac6aab5a.png";